import { IoCheckmarkCircle, IoChevronBack, IoClose } from "react-icons/io5";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Post } from '../../compornents/Post';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons'
import { toast } from 'react-toastify';
import { Gtag, Linetag, FacebookPixel, Analytics } from '../../compornents/Analytics';

export const MenuDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [item, setItem] = useState(null);
  const [customer, setCustomer] = useState([]);
  const [lpspot, setLpspot] = useState(null);
  const [activeFaq, setActiveFaq] = useState(null);
  const [futon, setFuton] = useState([]); // デフォルト価格

  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
    // preventScroll: true
  });

  useEffect(() => {
    if (location.state?.data) {
      setItem(location.state.data.item);
      setCustomer(location.state.data.customer);
      setLpspot(location.state.data.lpspot);
    } else {
      // データがない場合はホームに戻る
      navigate('/home');
    }
  }, [location.state, navigate]);

  // 布団の価格を取得
  useEffect(() => {
    const fetchFuton = async () => {
      try {
        const response = await Post('post', '/order/futon_item.php', {});
        if (response && response.result === 1 && response.items && response.items.length > 0) {
          setFuton(response.items[0]);
        }
      } catch (error) {
        console.error('布団価格の取得エラー:', error);
        // エラー時はデフォルト価格を使用
      }
    };

    fetchFuton();
  }, []);

  // 注文を開始
  async function startOrder() {
    if (!item) return;

    Gtag('select_item', { item_id: item.id });
    Linetag('ViewItemDetail');
    FacebookPixel('AddToCart');
    openLoadingModal();

    // 見積もり取得
    const request_data = { item_id: item.id,lpspot_id:item.lpspot.id }
    const response_data = await Post('post', '/order/quote.php', request_data);

    if (response_data.result === 1) {
      const quote = response_data.quote;
      navigate("/confirm", {
        state: {
          data: {
            item: item,
            quote: quote,
            customer: customer,
            lpspot: lpspot,
            user_dropoff_type: 'uber',
            from: "menu_detail"
          }
        }
      });
    } else {
      toast.error(response_data.error_message);
    }
    closeLoadingModal();
  }

  // 戻るボタン
  const goBack = () => {
    navigate('/home');
  }

  // ホームへ
  const toHome = () => {
    navigate('/home');
  }

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  if (!item) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="text-center">
          <TailSpin stroke="#000" />
          <div className="mt-2">読み込み中...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="MenuDetailLP">
        <Analytics title="ふとん宅配クリーニング" />

        {/* ヘッダー */}
        <div className="toolbar bg-white border-t border-gray-200">
          <div className="toolbar_left">
            <IoChevronBack onClick={goBack} className="cursor-pointer" />
          </div>
          <div className="toolbar_center">
            ふとん宅配クリーニング
          </div>
          <div className="toolbar_right">
            <IoClose onClick={toHome} className="cursor-pointer" />
          </div>
        </div>

        {/* ヒーローセクション */}
        <section className="py-16 px-6 text-center" style={{background: 'linear-gradient(180deg, #fefce8 0%, #ffffff 100%)'}}>
          <h1 className="text-3xl font-bold m-0 leading-tight" style={{color: '#0E1D11'}}>
            毎日の睡眠を<br />もっと快適に
          </h1>
          <div className="text-lg m-0 mt-4" style={{color: '#6b7280'}}>
            ふとん
          </div>
          <div className="text-lg mb-5" style={{color: '#6b7280'}}>
            クリーニング
          </div>

          <div className="relative mb-4">
            <img
              src='/img/iStock-1161232231.jpg'
              alt="清潔で快適な寝室"
              className="w-full max-w-md mx-auto rounded-xl shadow-lg"
              loading="lazy"
            />
          </div>

          <button
            onClick={startOrder}
            className="btn btn-oval btn-yellow mb-4"
            style={{padding: '15px 20px', fontSize: '18px', fontWeight: 'bold'}}
          >
            {item.name}を注文
          </button>

        </section>

        {/* 選ばれる理由セクション */}
        <section className="bg-white py-12 px-6">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            選ばれる3つの理由
          </h2>
          <div className="space-y-6">
            <div className="bg-gray-50 p-6 rounded-xl">
              <div className="flex items-center mb-3">
                <div className="step-number">1</div>
                <h3 className="text-lg font-semibold text-gray-800">
                 かんたん<br/>集荷・配送
                </h3>
              </div>
              <p className="text-gray-600">
                重い布団を運ぶ必要なし。ご自宅まで最短15分で集荷に伺い、クリーニング後もご自宅までお届けします。
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl">
              <div className="flex items-center mb-3">
                <div className="step-number">2</div>
                <h3 className="text-lg font-semibold text-gray-800">
                 ふわふわな仕上がり
                </h3>
              </div>
              <p className="text-gray-600">
                花粉や黄砂を布団に寄せつけず、さらっと快適な仕上がりに。
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl">
              <div className="flex items-center mb-3">
                <div className="step-number">3</div>
                <h3 className="text-lg font-semibold text-gray-800">
                  高温乾燥＆<br/>抗菌仕上げで清潔
                </h3>
              </div>
              <p className="text-gray-600">
                工場での高温乾燥処理により、ダニ・カビ・アレルゲンを徹底除去。抗菌加工で長時間清潔を保ちます。
              </p>
            </div>
          </div>
        </section>

        {/* 注文の流れセクション */}
        <section className="bg-gray-50 py-12 px-6">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            かんたん5ステップ
          </h2>

          <div className="space-y-4">
            <div className="bg-white p-4 rounded-lg my-4">
              <p className="text-md font-bold text-gray-800 mb-2">1. ふとん専用バッグ注文</p>
              <p className="text-gray-600">スマホから簡単注文。最短15分でお届け。</p>
            </div>

            <div className="bg-white p-4 rounded-lg my-4">
              <p className="text-md font-bold text-gray-800 mb-2">2. ふとんメニュー注文</p>
              <p className="text-gray-600">ふとん専用バッグにふとんを詰めて注文完了。</p>
            </div>

            <div className="bg-white p-4 rounded-lg my-4">
              <p className="text-md font-bold text-gray-800 mb-2">3. 集荷</p>
              <p className="text-gray-600">自宅で受け渡し。重いふとんもラクラク。</p>
            </div>

            <div className="bg-white p-4 rounded-lg my-4">
              <p className="text-md font-bold text-gray-800 mb-2">4. クリーニング</p>
              <p className="text-gray-600">クリーニング完了後、お知らせします。</p>
            </div>

            <div className="bg-white p-4 rounded-lg my-4">
              <p className="text-md font-bold text-gray-800 mb-2">5. お受け取り</p>
              <p className="text-gray-600">7-10日でふわふわ清潔なふとんをお届け。</p>
            </div>
          </div>
        </section>

        {/* 専用バッグについて */}
        <section className="bg-white py-12 px-6">
          <div className="text-center mb-2">
            <img
              src="/img/futon_bag.png"
              alt="ふとん専用バッグの使用例"
              className="w-full max-w-lg mx-auto rounded-lg shadow-md"
              loading="lazy"
            />
          </div>

          <h3 className="text-xl font-bold text-center mb-4 text-gray-800">
            「ふとん専用バッグ」について
          </h3>

          <p className="text-center text-sm text-gray-600 mb-4">
            ふとん専用バッグサイズ：97cm × 63cm × 35cm（195cm）
          </p>

          <div className="bg-gray-50 p-6 rounded-xl">
            <p className="text-gray-700 leading-relaxed">
              ※衣類用の専用バッグとは異なります。<br />
              ※そのまま布団を入れるとシングルの掛布団、
              敷布団あわせて2枚から3枚程度入ります。
            </p>
          </div>
        </section>

        {/* 料金プランセクション */}
        <section className="bg-white py-12 px-6">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            わかりやすい料金設定
          </h2>

          <div className="bg-blue-50 rounded-xl p-6 text-center shadow-md">
            <p className="text-gray-600 text-sm mb-4"><img src={futon?.img} className="w-full max-w-lg mx-auto rounded-lg shadow-md" alt="Item" /></p>
            <div className="price-highlight text-4xl mb-2">
              ¥{Number(futon?.kin2)?.toLocaleString()}
            </div>
            <p className="text-gray-600 text-sm mb-4">（税込）</p>

            <p className="text-sm mb-3 font-medium">
              ふとん専用バッグをお受け取り後、注文できるようになります。
            </p>
            <div className="bg-white rounded-lg p-4 text-left">

              <p className="text-sm text-gray-600 mb-3 font-medium">含まれるサービス：</p>
              <div className="space-y-2 text-sm">
                <div className="flex items-center">
                  <IoCheckmarkCircle className="text-green-500 mr-2" />
                  <span>羽毛・綿・化繊 すべて対応可能</span>
                </div>
                <div className="flex items-center">
                  <IoCheckmarkCircle className="text-green-500 mr-2" />
                  <span>ふとん専用バッグでの集荷・配送</span>
                </div>
                <div className="flex items-center">
                  <IoCheckmarkCircle className="text-green-500 mr-2" />
                  <span>高温乾燥・抗菌加工</span>
                </div>
                <div className="flex items-center">
                  <IoCheckmarkCircle className="text-green-500 mr-2" />
                  <span>7-10日でお届け</span>
                </div>
              </div>
            </div>

            <p className="text-xs text-gray-500 mt-4">
              ※Uber配送手数料は別途必要です
            </p>
          </div>
        </section>

        {/* FAQセクション */}
        <section className="bg-white py-12 px-6 pb-20">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">
            よくあるご質問
          </h2>

          <div className="space-y-3">
            <div className="faq-item">
              <button
                className="faq-question"
                onClick={() => toggleFaq(0)}
              >
                <span>羽毛布団は洗えますか？</span>
                <span className="text-blue-600">{activeFaq === 0 ? '−' : '＋'}</span>
              </button>
              {activeFaq === 0 && (
                <div className="faq-answer">
                  はい、羽毛布団も安心してお任せください。羽毛専用の洗浄・乾燥工程で、羽毛を傷めることなくふわふわに仕上げます。
                </div>
              )}
            </div>

            <div className="faq-item">
              <button
                className="faq-question"
                onClick={() => toggleFaq(1)}
              >
                <span>納期はどれくらい？</span>
                <span className="text-blue-600">{activeFaq === 1 ? '−' : '＋'}</span>
              </button>
              {activeFaq === 1 && (
                <div className="faq-answer">
                  通常、集荷から7〜10日程度でお届けいたします。繁忙期（6〜9月）は多少お時間をいただく場合がございます。
                </div>
              )}
            </div>

            <div className="faq-item">
              <button
                className="faq-question"
                onClick={() => toggleFaq(2)}
              >
                <span>カビ・ダニは除去されますか？</span>
                <span className="text-blue-600">{activeFaq === 2 ? '−' : '＋'}</span>
              </button>
              {activeFaq === 2 && (
                <div className="faq-answer">
                  高温乾燥処理により、ダニ・カビ・アレルゲンを徹底除去いたします。抗菌加工も施し、清潔な状態を長時間保ちます。
                </div>
              )}
            </div>

            <div className="faq-item">
              <button
                className="faq-question"
                onClick={() => toggleFaq(3)}
              >
                <span>圧縮して返ってきますか？</span>
                <span className="text-blue-600">{activeFaq === 3 ? '−' : '＋'}</span>
              </button>
              {activeFaq === 3 && (
                <div className="faq-answer">
                  ふわふわの状態でお返しいたします。圧縮はせず、専用の配送袋でお届けするため、すぐにご使用いただけます。
                </div>
              )}
            </div>

          </div>
        </section>

        {/* 固定CTAボタン */}
        <div className="fixed-cta">
          <button
            onClick={startOrder}
            className="btn btn-oval btn-yellow w-full"
            style={{fontSize: '18px', fontWeight: 'bold', padding: '15px'}}
          >
            {item.name}を注文
          </button>
        </div>
      </div>

      <LoadingModal>
        <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
          <button onClick={closeLoadingModal} className="hide">閉じる</button>
          <div>
            <TailSpin stroke="#000" />
          </div>
          <div className="">
            <div className="">
              処理中です
            </div>
          </div>
        </div>
      </LoadingModal>
    </div>
  );
};
